module.exports = __webpack_public_path__ + "img/watermark.02e31852.svg";